import React, { useCallback } from 'react'
import { List } from '@mui/material'
import LoadingPage from 'components/LoadingPage'
import Suspense from 'components/Suspense'
import { IUploadedVideo } from 'hooks/video'
import { useSnackbar } from 'hooks/redux'
import { SuggestedQuestionsList_Questions$key } from '__generated__/SuggestedQuestionsList_Questions.graphql'
import { graphql, useFragment } from 'react-relay'
import { SuggestedQuestionsList_User$key } from '__generated__/SuggestedQuestionsList_User.graphql'
import QuestionAnswerListItem from '../QuestionAnswerListItem'
import useStyles from './styles'

interface ISuggestedQuestionsListProps {
  questionsFragmentRef?: SuggestedQuestionsList_Questions$key
  userFragmentRef: SuggestedQuestionsList_User$key
  onVideoSaved?: (video: IUploadedVideo) => void
  finished?: boolean

  /** @deprecated */
  onAnswerSaved?: () => void
}

const SuggestedQuestionsList = (props: ISuggestedQuestionsListProps) => {
  const { classes } = useStyles()
  const {
    questionsFragmentRef,
    userFragmentRef,
    onVideoSaved,
    onAnswerSaved,
    finished = false,
  } = props

  const user = useFragment(graphql`
    fragment SuggestedQuestionsList_User on User {
      ...QuestionAnswerListItem_User
    }
  `, userFragmentRef)

  const questions = useFragment<SuggestedQuestionsList_Questions$key>(graphql`
    fragment SuggestedQuestionsList_Questions on Question @relay(plural: true) {
      id
      ...QuestionAnswerListItem_Question
    }
  `, questionsFragmentRef)

  const { showSnackbarMessage } = useSnackbar()
  const onError = useCallback((error: any) => showSnackbarMessage(error.response || error.message || 'Upload Failed', { level: 'error' }), [showSnackbarMessage]) // TODO: fix typings here

  return (
    <Suspense fallback={<LoadingPage />}>
      <List disablePadding className={classes.list}>
        {questions?.map((question, index) => (
          <QuestionAnswerListItem
            userFragmentRef={user}
            index={index + 1}
            questionFragmentRef={question}
            onVideoSaved={onVideoSaved}
            onAnswerSaved={onAnswerSaved}
            key={question?.id}
            onError={onError}
            finished={finished}
          />
        ))}
      </List>
    </Suspense>
  )
}

export default React.memo(SuggestedQuestionsList)
